import Cities from './Cities.redux';

export default Cities;
